import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {MouseEvent} from 'react';
import {Stack} from '@mui/material';

import {formatNotificationDate} from '../helpers/format-notification-date';
import {AppNotification} from '../types/notifications.types';
import {
  BackButton,
  NotificationDetailsCard,
  NotificationDetailsDate,
  NotificationDetailsHeader,
  NotificationDetailsMessage,
  NotificationDetailsRoot,
  NotificationDetailsTitle,
  NotificationsTitle,
  NotificationMenuButton,
} from './notifications.styles';

interface NotificationDetailsProps {
  notification: AppNotification;
  onBack: VoidFunction;
  onOpenNotificationActions: (event: MouseEvent<HTMLElement>, id: string) => void;
}

export const NotificationDetails = ({notification, onBack, onOpenNotificationActions}: NotificationDetailsProps) => {
  const formattedDate = formatNotificationDate(notification.createDate)
    .replace('Сегодня ', 'Сегодня в ')
    .replace('Вчера ', 'Вчера в ');

  return (
    <>
      <NotificationDetailsHeader direction="row" alignItems="flex-start" justifyContent="space-between">
        <Stack direction="row" alignItems="center" gap={1}>
          <BackButton onClick={onBack} aria-label="Назад к списку уведомлений">
            <ArrowBackIcon sx={{fontSize: 20}} />
          </BackButton>
          <NotificationsTitle sx={{fontFamily: 'Inter', lineHeight: '19px', color: '#000000'}}>
            Уведомления
          </NotificationsTitle>
        </Stack>
        <NotificationMenuButton
          onClick={(event) => onOpenNotificationActions(event, notification.id)}
          aria-label="Действия с уведомлением"
        >
          <MoreVertIcon />
        </NotificationMenuButton>
      </NotificationDetailsHeader>
      <NotificationDetailsRoot>
        <NotificationDetailsCard>
          <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
            <NotificationDetailsTitle>{notification.title}</NotificationDetailsTitle>
            <Stack direction="row" alignItems="center" gap={0.5}>
              <AccessTimeOutlinedIcon sx={{fontSize: 16, color: '#696F8C'}} />
              <NotificationDetailsDate>{formattedDate}</NotificationDetailsDate>
            </Stack>
          </Stack>
          <NotificationDetailsMessage>{notification.message}</NotificationDetailsMessage>
        </NotificationDetailsCard>
      </NotificationDetailsRoot>
    </>
  );
};
